(function () {
        'use strict';

        angular.module('soopkitchenApp').controller('PlanningDetailController', PlanningDetailController);
        PlanningDetailController.$inject = ['PlanningDetailOpenDialogService', 'ObservationDefinitions', 'EventCollections', 'PlanningDetailService', 'SoopService', 'ObsService', 'EventsService',
            '$scope', '$window', '$stateParams', '$state', 'previousState', 'entity',
            'Planning', '$uibModal', 'AlertService', 'AutomaticEventService', '$cookies',
            'SoopkitchenUtils', '$timeout', '$document', '$sce', 'PlanningEventsService',
            'PlanTypes', '$http', 'Principal'];

        function PlanningDetailController(PlanningDetailOpenDialogService, ObservationDefinitions, EventCollections, PlanningDetailService, SoopService, ObsService, EventsService,
                                          $scope, $window, $stateParams, $state, previousState, entity,
                                          Planning, $uibModal, AlertService, AutomaticEventService, $cookies,
                                          SoopkitchenUtils, $timeout, $document, $sce, PlanningEventsService, PlanTypes, $http, Principal) {

            var vm = this;
            PlanningDetailService.setController(this);
            PlanningDetailOpenDialogService.setController(this);
            vm.planType = $stateParams.planType;

            vm.isMaster = vm.planType == PlanTypes['master'];
            vm.isChild = vm.planType == PlanTypes['child'];
            vm.isTemplate = vm.planType == PlanTypes['template'];
            vm.isSoop = vm.planType == PlanTypes['soop'];
            vm.isTimelineWithNoDates = vm.isTemplate || vm.isSoop;
            vm.hasSoops = vm.isMaster || vm.isChild;

            /** ** Constants *** */
            var IN_SITU_INSTRUMENTS = ['EPD', 'MAG', 'RPW', 'SWA'];
            var REMOTE_SENSING_INSTRUMENTS = ['EUI', 'Metis', 'PHI', 'SPICE', 'STIX', 'SoloHI'];

            /** ** Properties *** */
            vm.changeEvCollecVisible = false;
            vm.changeObsDefVisible = false;
            vm.changeParentVisible = false;
            vm.planning = entity;

            vm.observationsPerInstrument = vm.planning.observationDefinitions.allExperimentsObservationDefinitions;
            vm.status = AutomaticEventService.getStatus(vm.planning.automaticEventStatus);
            if (vm.isMaster) {
                vm.moreInfo = $sce.trustAsHtml('Event Schema: <b><span id="schemaName">' + vm.planning.schemaName
                    + '</span></b><br>' + 'Schema Version: <b><span id="schemaVersion">' + vm.planning.schemaVersion
                    + '</span></b><br>' + 'Plan Profile: <b><span id="planProfile">' + vm.planning.presentationProfile
                    + '</span></b><br>' + 'Plan Limit Start: <b><span id="planLimitStart">' + vm.planning.validityStartTime
                    + '</span></b><br>' + 'Plan Limit End: <b><span id="planLimitEnd">' + vm.planning.validityEndTime
                    + '</span></b><br>' + 'Events Start: <b><span id="eventsStart">'
                    + vm.planning.eventCollections.validityStartTime + '</span></b><br>' + 'Events End: <b><span id="eventsEnd">'
                    + vm.planning.eventCollections.validityEndTime + '</span></b>');
            }

            vm.showPlanToImport = false;
            vm.selectedPlanToImport = "";
            vm.rsInstruments = REMOTE_SENSING_INSTRUMENTS;
            vm.isInstruments = IN_SITU_INSTRUMENTS;
            vm.instruments = REMOTE_SENSING_INSTRUMENTS.concat(IN_SITU_INSTRUMENTS);
            vm.previousState = previousState;
            vm.checkedValue = {};
            vm.isVersion = $stateParams.internalVersion > 0;
            vm.showDelta = {};
            vm.isLockedColor = "white";
            vm.picker = {date: ''};
            vm.picker2 = {date: ''};
            vm.pickerPoint1 = {date: ''};
            vm.pickerPoint2 = {date: ''};
            vm.duration = 0;
            vm.durationLetters = null;
            vm.checkedAll = false;
            vm.isEfecs = vm.planning.schemaName == "e-fecs";

            /* Methods */
            vm.submitNewEvCollection = PlanningDetailService.submitNewEvCollection;
            vm.submitNewObsDef = PlanningDetailService.submitNewObsDef;
            vm.soopify = PlanningDetailService.soopify;
            vm.unsoopify = PlanningDetailService.unsoopify;
            vm.openProfile = PlanningDetailService.openProfile;
            vm.updateDuration = PlanningDetailService.updateDuration;
            vm.applyWidth = PlanningDetailService.applyWidth;
            vm.applyPoints = PlanningDetailService.applyPoints;
            vm.updateLetters = PlanningDetailService.updateLetters;
            vm.durationLettersInvalid = PlanningDetailService.durationLettersInvalid;
            vm.panic = PlanningDetailService.panic;
            vm.bookMark = PlanningDetailService.bookMark;
            vm.saveBaseline = PlanningDetailService.saveBaseline;
            vm.updateEndDate = PlanningDetailService.updateEndDate;
            vm.invalidateDateRange = PlanningDetailService.invalidateDateRange;
            vm.unlock = PlanningDetailService.unlock;
            vm.search = PlanningDetailService.search;
            vm.openAutomaticEventWindow = PlanningDetailService.openAutomaticEventWindow;
            vm.showAutomaticButton = PlanningDetailService.showAutomaticButton;
            vm.canUpdateObsDef = PlanningDetailService.canUpdateObsDef;
            vm.canUpdateParent = PlanningDetailService.canUpdateParent;
            vm.canUpdateEvents = PlanningDetailService.canUpdateEvents;
            vm.toggleCheckAll = PlanningDetailService.toggleCheckAll;
            vm.resetWidth = PlanningDetailService.resetWidth;
            vm.setValidityPeriod = PlanningDetailService.setValidityPeriod;
            vm.resetZoomedDates = PlanningDetailService.resetZoomedDates;
            vm.zoomIn = PlanningDetailService.zoomIn;
            vm.zoomOut = PlanningDetailService.zoomOut;
            vm.movePlanLeft = PlanningDetailService.movePlanLeft;
            vm.movePlanRight = PlanningDetailService.movePlanRight;
            vm.reload = PlanningDetailService.reload;
            vm.goBack = PlanningDetailService.goBack;
            vm.updateParent = PlanningDetailService.updateParent;
            vm.getPickerDate = PlanningDetailService.getPickerDate;
            vm.setPickerDate = PlanningDetailService.setPickerDate;
            vm.getPickerDate2 = PlanningDetailService.getPickerDate2;
            vm.setPickerDate2 = PlanningDetailService.setPickerDate2;
            vm.getPickerPoint1 = PlanningDetailService.getPickerPoint1;
            vm.getPickerPoint2 = PlanningDetailService.getPickerPoint2;

            var soopsGroup = 'SOOPs';

            /** ** Main *** */
            vm.planToImport = [];
            findPlansToImport();
            // var options = null;
            vm.dateRange = getDateRange();
            vm.duration = (Date.parse(vm.getPickerDate2()) - Date.parse(vm.getPickerDate())) / 1000;
            vm.durationLetters = SoopkitchenUtils.secondsToTime(vm.duration);

            vm.isValidDate = SoopkitchenUtils.isValidDate;
            vm.findPlansToImport = findPlansToImport;
            vm.importPlan = importPlan;
            vm.manageUsers = PlanningDetailOpenDialogService.manageUsers;
            vm.insertPlan = PlanningDetailOpenDialogService.insertPlan;
            vm.setEfecsVersion = PlanningDetailOpenDialogService.setEfecsVersion;
            vm.insertSOCEvents = PlanningDetailOpenDialogService.insertSOCEvents;
            vm.expandEvents = expandEvents;
            vm.canImport = canImport;
            vm.openContextMenu = openContextMenu;
            vm.rightClickAction = rightClickAction;

            //Events

            $document.click(function (e) {
                e.stopPropagation();
                closeContextMenu();
            });

            $scope.$on("updateList", function (e, a) {
                PlanningDetailService.resetZoomedDates();
                PlanningDetailService.resetScroll();
                reloadPlan(a.newOccurrance, a.data);
            });

            $scope.$on("cancelMovement", function () {
                reloadPlan();
            });

            generatePage();

            /** ** Auxiliary Functions *** */

            function failure(response) {
                SoopkitchenUtils.prettyError(response);
            }

            function successLoadLatestPlanLabels(data) {
                vm.parentPlans = [];
                vm.parentPlans.push("");
                for (var i = 0; i < data.length; i++) {
                    if (vm.planning.parentLabel !== data[i].label) {
                        vm.parentPlans.push(data[i].label);
                    }
                }
                vm.selectedNewParentLabel = vm.parentPlans[0];
            }

            function successLoadObservationDefinitions(response) {
                if (response.data) {
                    var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                    var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                    vm.observationDefinitions = [];
                    vm.observationDefinitions.push("");
                    sortedData.forEach(function (item) {
                        if (vm.planning.observationDefinitions.label !== item.label) {
                            vm.observationDefinitions.push(item.label);
                        }
                    });
                    vm.selectedNewObservationDefinitions = vm.observationDefinitions[0];
                }
            }

            function successLoadEventCollections(response) {
                if (response.data) {
                    var data = angular.isArray(response.data) ? response.data : angular.fromJson(response.data);
                    var sortedData = SoopkitchenUtils.sort(data, 'timestamp', true);
                    vm.eventCollections = [];
                    vm.eventCollections.push("");
                    sortedData.forEach(function (item) {
                        if (vm.planning.eventCollections.label !== item.label) {
                            vm.eventCollections.push(item.label);
                        }
                    });
                    vm.selectedNewEventCollections = vm.eventCollections[0];
                }
            }

            function canImport() {
                return vm.planning.label !== vm.selectedPlanToImport && vm.selectedPlanToImport;
            }

            function getDateRange() {
                var earliestDate;
                var latestDate;
                if (vm.isMaster) {
                    earliestDate = vm.planning.eventCollections.validityStartTime.substring(0, 10);
                    latestDate = vm.planning.eventCollections.validityEndTime.substring(0, 10);
                } else {
                    earliestDate = vm.planning.validityStartTime.substring(0, 10);
                    latestDate = vm.planning.validityEndTime.substring(0, 10);
                }

                if ($cookies.get(PlanningDetailService.getCookiePrefix() + "earliestDate") != null && $cookies.get(PlanningDetailService.getCookiePrefix() + "latestDate")) {
                    earliestDate = $cookies.get(PlanningDetailService.getCookiePrefix() + "earliestDate");
                    latestDate = $cookies.get(PlanningDetailService.getCookiePrefix() + "latestDate");
                } else {
                    $cookies.put(PlanningDetailService.getCookiePrefix() + "earliestDate", earliestDate);
                    $cookies.put(PlanningDetailService.getCookiePrefix() + "latestDate", latestDate);
                }

                vm.setPickerDate(earliestDate.substring(0, 10));
                vm.setPickerDate2(latestDate.substring(0, 10));

                return [earliestDate, latestDate];
            }

            function reloadPlan(newOccurrence, data) {
                if (data != null) {
                    PlanningDetailService.createTimeLine(data, newOccurrence, vm.checkedValue);

                } else {
                    Planning.get(
                        {
                            planType: vm.planType,
                            id: vm.planning.label
                        },
                        function successCallback(data) {
                            PlanningDetailService.createTimeLine(data, newOccurrence, vm.checkedValue);
                        },
                        function errorCallback(data) {
                        }
                    )
                }
            }

            function findPlansToImport() {
                vm.planToImport = [];
                vm.planToImport.push("");

                if (vm.isTimelineWithNoDates) {

                    Planning.getAllLatestPlans(
                        {
                            planType: PlanTypes['template']
                        },
                        function onSuccess(data, headers) {
                            for (var i = 0; i < data.length; i++) {
                                if (vm.planning.observationDefinitions.label === data[i].observationDefinitionsLabel && vm.planning.label !== data[i].label) {
                                    vm.planToImport.push(data[i].label);
                                }
                            }
                        },
                        function errorCallback(error) {
                        }
                    );
                }
            }


            function importPlan() {
                Planning.importTemplate(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        importLabel: vm.selectedPlanToImport,
                    },
                    function successCallback(data) {
                        SoopkitchenUtils.invokeSweetAlert("Nice!", "You have imported all observation instances from " + vm.selectedPlanToImport, "success");
                        reloadPlan(null, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function expandEvents() {
                $http({
                    method: 'PUT',
                    url: 'api/plan/event/expand?planLabel=' + vm.planning.label
                }).then(function success(response) {
                    SoopkitchenUtils.processResponse(
                        response,
                        "Events Expanded!",
                        "All possible events have been expanded",
                        function () {
                            location.reload();
                        });
                }, function error(response) {
                    SoopkitchenUtils.prettyError(response);
                });
            }

            function generatePage() {
                if (vm.isMaster) {
                    EventCollections.getEventCollections(successLoadEventCollections, failure);
                }
                ObservationDefinitions.getObservationDefinitions(successLoadObservationDefinitions, failure, vm.isMaster);
                if (vm.isChild) {
                    Planning.getAllLatestPlans({planType: PlanTypes['master']}, successLoadLatestPlanLabels, failure);
                }
                Planning.getMeta(
                    {
                        id: vm.planning.label,
                    },
                    function successCallback(response) {
                        createOptions(response.locked, vm);
                        vm.isLockedColor = isLockedColor();
                        PlanningDetailService.createTimeLine();
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                )
            }

            function createOptions(isLocked, vm) {

                vm.isLocked = isLocked;
                var minDate;
                var maxDate;
                if (vm.isMaster) {
                    minDate = vm.planning.eventCollections.validityStartTime;
                    maxDate = vm.planning.eventCollections.validityEndTime;
                } else {
                    minDate = vm.planning.validityStartTime;
                    maxDate = vm.planning.validityEndTime;
                }
                vm.options = {

                    orientation: 'both',
                    multiselect: true,
                    multiselectPerGroup: true,
                    editable: true,
                    groupEditable: true,
                    groupOrder: function (a, b) {
                        return a.orderId - b.orderId;
                    },
                    stack: false,
                    stackSubgroups: true,
                    margin: {
                        item: {
                            horizontal: 0
                        }
                    },
                    moment: function (date) {
                        return vis.moment(date).utc();
                    },
                    tooltip: {
                        followMouse: false,
                        overflowMethod: 'cap'
                    },

                    min: minDate,
                    max: maxDate,
                    onMoving: function (item, callback) {
                        return false;
                    },
                    onAdd: function (item) {
                        onAddOccurrence(item);
                    },
                    onUpdate: function (item) {
                        onUpdateOccurrence(item);
                    },

                    onRemove: function (item, callback) {
                        onUpdateOccurrence(item);
                    }

                };
                if (vm.isTimelineWithNoDates) {
                    vm.options['format'] = {
                        minorLabels: {
                            weekday: 'DDD',
                            day: 'DDD',
                            week: 'DDD',
                            month: 'DDD',
                            year: 'DDD'
                        },
                        majorLabels: {
                            millisecond: 'DDD HH:mm:ss',
                            second: 'DDD HH:mm',
                            minute: 'DDD',
                            hour: 'DDD',
                            weekday: '',
                            day: '',
                            week: '',
                            month: '',
                            year: ''
                        }
                    }
                }
                return vm.options;
            }

            function isLockedColor() {
                if (vm.isLocked || vm.isVersion)
                    return "gray";
                return "white";
            }

            function onAddOccurrence(item) {
                if (vm.isLocked === false && vm.isVersion === false) {
                    var adjustedStart = new Date(item.start);
                    adjustedStart.setSeconds(0, 0);
                    item.start = adjustedStart;

                    if (PlanningDetailService.isEventGroup(item.group)) {
                        if (vm.isMaster) {
                            PlanningDetailOpenDialogService.addEvent(item);
                        }
                    } else if (!isSoopGroup(item.group)) {
                        PlanningDetailOpenDialogService.addObservation(item)
                    }
                }
            }

            function onUpdateOccurrence(item) {
                if (vm.isLocked === false && vm.isVersion === false) {
                    if (PlanningDetailService.isEventGroup(item.group)) {
                        if (vm.isMaster) {
                            PlanningDetailOpenDialogService.updateEventViaDialog(item.occurrence, item.occurrence.startDate, item.occurrence.endDate, true);
                        }
                    } else if (!isSoopGroup(item.group)) {
                        PlanningDetailOpenDialogService.updateObservationViaDialog(item.occurrence, item.occurrence.startDate, item.occurrence.endDate, true);
                    } else if (isSoopGroup(item.group)) {
                        PlanningDetailOpenDialogService.editSoop(item);
                    }
                }
            }

            vm.isSocRole = false;
            Principal.hasAnyAuthority(['ROLE_PLAN_COORDINATOR', 'ROLE_POWER_USER']).then(function (result) {
                if (result) {
                    vm.isSocRole = true;
                }
            });

            vm.hasBeenAddedToThePlan = false;
            Principal.isInUsers(vm.planning.planUserInfo.usersWithRights).then(function (result) {
                if (result) {
                    vm.hasBeenAddedToThePlan = true;
                }
            });

            vm.isPlanOwner = false;
            Principal.isUser(vm.planning.planUserInfo.owner).then(function (result) {
                if (result) {
                    vm.isPlanOwner = true;
                }
            });

            vm.isInstrumentCoordinator = false;
            Principal.hasAuthority("ROLE_INSTRUMENT_COORDINATOR").then(function (result) {
                if (result) {
                    vm.isInstrumentCoordinator = true;
                }
            });

            vm.isInstrumentCoordinatorOrMember = true;
            Principal.hasAnyAuthority("ROLE_INSTRUMENT_COORDINATOR", "ROLE_INSTRUMENT_TEAM_MEMBER").then(function (result) {
                if (result) {
                    vm.isInstrumentCoordinatorOrMember = true;
                }
            });
            vm.socEvents = [];
            PlanningEventsService.getSOCEvents(
                {},
                function successCallback(data, status, headers, config) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(function (eventName, index) {
                            vm.socEvents.push(eventName);
                        });
                    }
                },
                function errorCallback(response) {
                });
            function canDoSoopContextMenu() {
                return (vm.isMaster && (vm.isSocRole || (vm.isInstrumentCoordinator && vm.hasBeenAddedToThePlan))) ||
                    (vm.isChild && (vm.isSocRole || vm.isPlanOwner || (vm.isInstrumentCoordinatorOrMember && vm.hasBeenAddedToThePlan)));
            }

            function canDoEventContextMenu() {
                return vm.isMaster && vm.isSocRole;
            }

            function canDoObsContextMenu() {
                return (vm.isMaster && (vm.isSocRole || (vm.isInstrumentCoordinator && vm.hasBeenAddedToThePlan))) ||
                    ((vm.isSoop || vm.isTemplate || vm.isChild) && (vm.isSocRole || vm.isPlanOwner || (vm.isInstrumentCoordinatorOrMember && vm.hasBeenAddedToThePlan)));
            }

            function always() {
                return true;
            }

            vm.isThereContextMenu = false;
            vm.selectionCount = 0;
            vm.onlyObsSelection = false;
            vm.onlyEventSelection = false;
            vm.onlySoopSelection = false;
            vm.selectedOccurrences = [];
            vm.clickedVisTime = null;

            function whenOnlyEventsSelected() {
                return vm.onlyEventSelection;
            }

            function whenOnlySoopSelected() {
                return vm.onlySoopSelection;
            }

            function whenOnlyObsSelected() {
                return vm.onlyObsSelection;
            }

            function whenSelectionCountIs(nr) {
                return function () {
                    return vm.selectionCount === nr;
                }
            }
            function whenStartEndPointing() {
                return function () {
                    if (vm.selectedOccurrences.length <2){
                        return false;
                    }
                    var first =  vm.selectedOccurrences[0];
                    var last =  vm.selectedOccurrences[vm.selectedOccurrences.length-1];
                    return first.name.startsWith("POINT") && first.name!=="POINT_CENTRE" && last.name.startsWith("POINT")  && last.name!=="POINT_CENTRE" ;
                }
            }
            function whenPreviousActionIsAddToSoopActions() {
                return vm.lastMenuAction === vm.contextMenu.SELECT_OBS_TO_ADD_TO_SOOP;
            }

            function whenPreviousActionIsCopyDate() {
                return vm.lastMenuAction === vm.contextMenu.COPY_START_DATE || vm.lastMenuAction === vm.contextMenu.COPY_END_DATE;
            }

            function whenPreviousActionIsCutOrCopyEvent() {
                return vm.lastMenuAction === vm.contextMenu.CUT_EVENT || vm.lastMenuAction === vm.contextMenu.COPY_EVENT;
            }

            function whenPreviousActionIsCutOrCopySoop() {
                return vm.lastMenuAction === vm.contextMenu.CUT_SOOP || vm.lastMenuAction === vm.contextMenu.COPY_SOOP;
            }

            function whenPreviousActionIsCutOrCopyObs() {
                return vm.lastMenuAction === vm.contextMenu.CUT_OBS || vm.lastMenuAction === vm.contextMenu.COPY_OBS;
            }

            function observationsSelectedAreAttachedToSoop() {
                if (vm.selectedOccurrences.length === 0) {
                    return false;
                }
                return vm.selectedOccurrences.every(function(occ) {
                    if (!occ || !occ.compositeId || !occ.compositeId.compositeSoopIds || occ.compositeId.compositeSoopIds.length === 0) {
                        return false;
                    }
                    var soopIds = occ.compositeId.compositeSoopIds;
                    return !(soopIds.length === 1 && soopIds[0].encodedSoopType === '000');
                });
            }

            function and(f1, f2) {
                return function () {
                    return f1() && f2()
                }
            }

            function or(f1, f2) {
                return function () {
                    return f1() || f2()
                }
            }

            vm.copiedDate = null;
            vm.lastMenuAction = null;
            vm.markedOccurrences = [];

            vm.contextMenu = {
                CUT_SOOP: {
                    text: 'Cut SOOP',
                    action: markOccurrences,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlySoopSelected, whenSelectionCountIs(1))
                },
                CUT_EVENT: {
                    text: 'Cut event(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenOnlyEventsSelected
                },
                CUT_OBS: {
                    text: 'Cut observation(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                COPY_SOOP: {
                    text: 'Copy SOOP',
                    action: markOccurrences,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlySoopSelected, whenSelectionCountIs(1))
                },
                COPY_EVENT: {
                    text: 'Copy event(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenOnlyEventsSelected
                },
                COPY_OBS: {
                    text: 'Copy observation(s)',
                    action: markOccurrences,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                DELETE_EVENT: {
                    text: 'Delete event(s)',
                    action: deleteEvents,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenOnlyEventsSelected
                },
                DELETE_OBS: {
                    text: 'Delete observation(s)',
                    action: deleteObs,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                COPY_START_DATE: {
                    text: 'Copy start date',
                    action: copyStartDate,
                    userAccessPermitted: always,
                    contextPermitted: whenSelectionCountIs(1)
                },
                COPY_END_DATE: {
                    text: 'Copy end date',
                    action: copyEndDate,
                    userAccessPermitted: always,
                    contextPermitted: whenSelectionCountIs(1)
                },
                PASTE_EVENTS: {
                    text: 'Paste events',
                    action: pasteEventAtClickedTime,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AND_EDIT: {
                    text: 'Paste event and edit',
                    action: pasteEventAtClickedTimeAndEdit,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_START_TIME: {
                    text: 'Paste event at start time',
                    action: pasteEventAtStartTime,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_START_TIME_AND_EDIT: {
                    text: 'Paste event at start time and edit',
                    action: pasteEventAtStartTimeAndEdit,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_END_TIME: {
                    text: 'Paste event at end time',
                    action: pasteEventAtEndTime,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_EVENT_AT_END_TIME_AND_EDIT: {
                    text: 'Paste event at end time and edit',
                    action: pasteEventAtEndTimeAndEdit,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyEvent)
                },
                PASTE_OBS: {
                    text: 'Paste observations',
                    action: pasteObsAtClickedTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AND_EDIT: {
                    text: 'Paste observations and edit',
                    action: pasteObsAtClickedTimeAndEdit,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_START_TIME: {
                    text: 'Paste observations at start time',
                    action: pasteObsAtStartTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_START_TIME_AND_EDIT: {
                    text: 'Paste observations at start time and edit',
                    action: pasteObsAtStartTimeAndEdit,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_END_TIME: {
                    text: 'Paste observations at end time',
                    action: pasteObsAtEndTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_OBS_AT_END_TIME_AND_EDIT: {
                    text: 'Paste observations at end time and edit',
                    action: pasteObsAtEndTimeAndEdit,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopyObs)
                },
                PASTE_SOOP: {
                    text: 'Paste SOOP',
                    action: pasteSoopAtClickedTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AND_EDIT: {
                    text: 'Paste SOOP and edit',
                    action: pasteSoopAtClickedTimeAndEdit,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(0), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_START_TIME: {
                    text: 'Paste SOOP at start time',
                    action: pasteSoopAtStartTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_START_TIME_AND_EDIT: {
                    text: 'Paste SOOP at start time and edit',
                    action: pasteSoopAtStartTimeAndEdit,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_END_TIME: {
                    text: 'Paste SOOP at end time',
                    action: pasteSoopAtEndTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_SOOP_AT_END_TIME_AND_EDIT: {
                    text: 'Paste SOOP at end time and edit',
                    action: pasteSoopAtEndTimeAndEdit,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenPreviousActionIsCutOrCopySoop)
                },
                PASTE_AS_START_DATE: {
                    text: 'Paste as start date',
                    action: pasteAsStartDate,
                    userAccessPermitted: or(and(canDoEventContextMenu, whenOnlyEventsSelected), and(canDoObsContextMenu, whenOnlyObsSelected)),
                    contextPermitted: and(whenPreviousActionIsCopyDate, whenSelectionCountIs(1))
                },
                PASTE_AS_END_DATE: {
                    text: 'Paste as end date',
                    action: pasteAsEndDate,
                    userAccessPermitted: or(and(canDoEventContextMenu, whenOnlyEventsSelected), and(canDoObsContextMenu, whenOnlyObsSelected)),
                    contextPermitted: and(whenPreviousActionIsCopyDate, whenSelectionCountIs(1))
                },
                EXTEND_UNTIL_NEXT: {
                    text: 'Extend until next',
                    action: extendUntilNext,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenOnlyObsSelected)
                },
                EXTEND_TO_PREVIOUS: {
                    text: 'Extend to previous',
                    action: extendToPrevious,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: and(whenSelectionCountIs(1), whenOnlyObsSelected)
                },
                INSERT_SOOP_TEMPLATE_AT_TIME: {
                    text: 'Insert SOOP template',
                    action: insertSoopTemplateAtClickedTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenSelectionCountIs(0),
                },
                INSERT_SOOP_TEMPLATE_AT_START_TIME: {
                    text: 'Insert SOOP template at start time',
                    action: insertSoopTemplateAtStartTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenSelectionCountIs(1),
                },
                CHANGE_METIS_COMPABILITY_AT_START_TIME: {
                    text: 'Change METIS Compability for pointings at interval',
                    action: changeMetisCompatibilityAtInterval,
                    userAccessPermitted: canDoEventContextMenu,
                    contextPermitted: whenStartEndPointing(),
                },
                INSERT_SOOP_TEMPLATE_AT_END_TIME: {
                    text: 'Insert SOOP template at end time',
                    action: insertSoopTemplateAtEndTime,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenSelectionCountIs(1),
                },
                INSERT_PLAN_TEMPLATE_AT_TIME: {
                    text: 'Insert floating timeline',
                    action: insertPlanTemplateAtClickedTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenSelectionCountIs(0),
                },
                INSERT_PLAN_TEMPLATE_AT_START_TIME: {
                    text: 'Insert floating timeline at start time',
                    action: insertPlanTemplateAtStartTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenSelectionCountIs(1)
                },
                INSERT_PLAN_TEMPLATE_AT_END_TIME: {
                    text: 'Insert floating timeline at end time',
                    action: insertPlanTemplateAtEndTime,
                    userAccessPermitted: canDoObsContextMenu,
                    contextPermitted: whenSelectionCountIs(1)
                },
                SELECT_OBS_TO_ADD_TO_SOOP: {
                    text: 'Select observations for adding them to SOOP',
                    action: markOccurrences,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                CREATE_SOOP_FROM_SELECTED_OBS: {
                    text: 'Create SOOP/Floating Timeline from selection',
                    action: createSOOPFromTimeLine,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: whenOnlyObsSelected
                },
                ADD_SELECTED_OBS_TO_SOOP: {
                    text: 'Add selected observations to SOOP',
                    action: addObservationsToSOOP,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlySoopSelected, and(whenSelectionCountIs(1), whenPreviousActionIsAddToSoopActions))
                },
                DETACH_FROM_SOOP: {
                    text: 'Detach selected observations from SOOP',
                    action: detachObservationsFromSOOP,
                    userAccessPermitted: canDoSoopContextMenu,
                    contextPermitted: and(whenOnlyObsSelected, observationsSelectedAreAttachedToSoop)
                },
            };

            function rightClickAction(menuItem) {
                closeContextMenu();
                menuItem.action();
                vm.lastMenuAction = menuItem;
                vm.timeline.setSelection([], {})
            }

            function markOccurrences() {
                vm.markedOccurrences = vm.selectedOccurrences;
            }

            function copyStartDate() {
                vm.copiedDate = vm.selectedOccurrences[0].startDate;
            }

            function copyEndDate() {
                vm.copiedDate = vm.selectedOccurrences[0].endDate;
            }

            function pasteEventAtEndTime() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, false, vm.selectedOccurrences[0].endDate);
            }

            function pasteEventAtEndTimeAndEdit() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, true, vm.selectedOccurrences[0].endDate);
            }

            function pasteEventAtStartTime() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, false, vm.selectedOccurrences[0].startDate);
            }

            function pasteEventAtStartTimeAndEdit() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, true, vm.selectedOccurrences[0].startDate);
            }

            function pasteEventAtClickedTime() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, false, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteEventAtClickedTimeAndEdit() {
                pasteEvent(vm.lastMenuAction === vm.contextMenu.CUT_EVENT, true, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteSoopAtEndTime() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, false, vm.selectedOccurrences[0].endDate);
            }

            function pasteSoopAtEndTimeAndEdit() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, true, vm.selectedOccurrences[0].endDate);
            }

            function pasteSoopAtStartTime() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, false, vm.selectedOccurrences[0].startDate);
            }

            function pasteSoopAtStartTimeAndEdit() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, true, vm.selectedOccurrences[0].startDate);
            }

            function pasteSoopAtClickedTime() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, false, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteSoopAtClickedTimeAndEdit() {
                pasteSoop(vm.lastMenuAction === vm.contextMenu.CUT_SOOP, true, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteObsAtEndTime() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, false, vm.selectedOccurrences[0].endDate);
            }

            function pasteObsAtEndTimeAndEdit() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, true, vm.selectedOccurrences[0].endDate);
            }

            function pasteObsAtStartTime() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, false, vm.selectedOccurrences[0].startDate);
            }

            function pasteObsAtStartTimeAndEdit() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, true, vm.selectedOccurrences[0].startDate);
            }

            function pasteObsAtClickedTime() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, false, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function pasteObsAtClickedTimeAndEdit() {
                pasteObs(vm.lastMenuAction === vm.contextMenu.CUT_OBS, true, SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function moveEndDate(occurrence, toDate) {
                var originalDurationMillis = Date.parse(occurrence.endDate) - Date.parse(occurrence.startDate);
                var endDate = new Date(new Date(Date.parse(toDate)).getTime() + originalDurationMillis);
                return SoopkitchenUtils.formattedDate(endDate);
            }

            function successCallback(response) {
                return function () {
                    SoopkitchenUtils.updatePlanFromDialog(response.data);
                }
            }

            function confirmAction(title, message, action) {
                SoopkitchenUtils.prettyConfirmHtml(title, message, function (ok) {
                    if (ok) {
                        action();
                    }
                });
            }

            function pasteSoop(cut, openUpdateMenu, date) {
                var soopInstance = vm.markedOccurrences[0];
                if (openUpdateMenu) {
                    PlanningDetailOpenDialogService.moveSoop(soopInstance, date, cut);
                } else {
                    var titlePrefix = "Copy and paste";
                    if (cut) titlePrefix = "Cut and paste";

                    var title = titlePrefix + ' SOOP:' + soopInstance.encodedSoopType + '_' + soopInstance.soopInstanceId;
                    confirmAction(title, 'Are you sure you want to ' + title, function () {
                        SoopService.moveSoop(vm.planType, vm.planning.label, soopInstance.soopInstanceId, soopInstance.encodedSoopType, soopInstance.soopType, date, cut, successCallback);
                    });
                }
            }

            function pasteObs(cut, openUpdateMenu, date) {

                var obsCount = vm.markedOccurrences.length;
                if (obsCount === 1 && openUpdateMenu) {
                    var newEndDate = moveEndDate(vm.markedOccurrences[0], date);
                    PlanningDetailOpenDialogService.updateObservationViaDialog(vm.markedOccurrences[0], date, newEndDate, cut);
                } else if (openUpdateMenu) {
                    PlanningDetailOpenDialogService.moveObs(vm.markedOccurrences, date, cut)
                } else {
                    var titlePrefix = "Copy and paste ";
                    if (cut) titlePrefix = "Cut and paste ";
                    var title = titlePrefix + vm.markedOccurrences.length + ' observations';
                    var msg = '<h4>Are you sure you want to ' + title + '</h4><hr/>';
                    msg += createObsHtmlTable(vm.markedOccurrences);
                    confirmAction(title, msg, function () {
                        ObsService.moveObs(vm.planType, vm.planning.label, vm.markedOccurrences, date, cut, successCallback);
                    });

                }
            }

            function deleteOccurrencesFunction(deleteFunction, occurrences, successMsg) {
                return function () {
                    deleteFunction(
                        {
                            planType: vm.planType,
                            planLabel: vm.planning.label
                        },
                        occurrences,
                        function successCallback(data) {
                            SoopkitchenUtils.updatePlanFromDialog(data);
                            AlertService.success(successMsg);
                        }, function (response) {
                            SoopkitchenUtils.prettyError(response);
                        }
                    );
                }
            }

            // function updateTimeLine(highlightOccurrance, data) {
            //
            //     if (highlightOccurrance) {
            //         $rootScope.$broadcast('updateList', {
            //             newOccurrance: vm.evaluatedObservation,
            //             oldOccurrance: parameters.occurrence,
            //             data: data
            //         });
            //
            //     } else {
            //         SoopkitchenUtils.updatePlanFromDialog(data);
            //         $uibModalInstance.dismiss('cancel');
            //
            //     }
            // }

            function createObsHtmlTable(obsArray) {
                var htmlTxt = '';
                htmlTxt += '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
                htmlTxt += '<table class="jh-table table table-striped"><tbody>';
                htmlTxt += '<thead><tr>';
                htmlTxt += '<th>Instrument</th>';
                htmlTxt += '<th>Module</th>';
                htmlTxt += '<th>Name</th>';
                htmlTxt += '<th>SOOP IDs</th>';
                htmlTxt += '<th>Start Date</th>';
                htmlTxt += '</tr></thead>';
                for (var i = 0; i < obsArray.length; i++) {
                    var soopIds = '';
                    for (var j = 0; j < obsArray[i].compositeId.compositeSoopIds.length; j++) {
                        soopIds += obsArray[i].compositeId.compositeSoopIds[j].encodedSoopType + '_' +
                            obsArray[i].compositeId.compositeSoopIds[j].soopInstanceId + ', '
                    }
                    soopIds = soopIds.substring(0, soopIds.length - 2);
                    htmlTxt += '<tr>';
                    htmlTxt += '<td align="left">' + obsArray[i].experiment + '</td>';
                    htmlTxt += '<td align="left">' + obsArray[i].module + '</td>';
                    htmlTxt += '<td align="left">' + obsArray[i].name + '</td>';
                    htmlTxt += '<td align="left">' + soopIds + '</td>';
                    htmlTxt += '<td align="left">' + obsArray[i].startDate + '</td>';
                    htmlTxt += '</tr>';
                }
                htmlTxt += '</tbody></table></div>';
                return htmlTxt;
            }

            function deleteObs() {
                var title = 'Remove observations';
                var msg = '<h4>Are you sure you want to delete ' + vm.selectedOccurrences.length + ' observations</h4><hr/>';
                msg += createObsHtmlTable(vm.selectedOccurrences);
                confirmAction(title, msg, deleteOccurrencesFunction(Planning.deleteObsInstance, vm.selectedOccurrences, "Deleted Observation successfully"));
            }

            function deleteEvents() {
                var title = 'Remove events';
                var msg = '<h4>Are you sure you want to delete ' + vm.selectedOccurrences.length + ' events</h4><hr/>';
                msg += '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
                msg += '<table class="jh-table table table-striped"><tbody>';
                msg += '<thead><tr>';
                msg += '<th>Name</th>';
                msg += '<th>Start Date</th>';
                msg += '</tr></thead>';
                for (var i = 0; i < vm.selectedOccurrences.length; i++) {
                    msg += '<tr>';
                    msg += '<td align="left">' + vm.selectedOccurrences[i].name + '</td>';
                    msg += '<td align="left">' + vm.selectedOccurrences[i].startDate + '</td>';
                    msg += '</tr>';
                    if (vm.socEvents.includes(vm.selectedOccurrences[i].name)) {
                        msg += '<tr><td colspan="2" style="color:red;">Warning: '+vm.selectedOccurrences[i].name+' is a SOC event and the expanded events will be also deleted</td></tr>';
                    }
                }
                msg += '</tbody></table></div>';
                confirmAction(title, msg, deleteOccurrencesFunction(PlanningEventsService.deleteEvent, vm.selectedOccurrences, "Deleted Events successfully"));
            }

            function pasteEvent(cut, openUpdateMenu, date) {
                var eventCount = vm.markedOccurrences.length;
                if (eventCount === 1 && openUpdateMenu) {
                    var newEndDate = moveEndDate(vm.markedOccurrences[0], date);
                    PlanningDetailOpenDialogService.updateEventViaDialog(vm.markedOccurrences[0], date, newEndDate, cut);
                } else if (openUpdateMenu) {
                    PlanningDetailOpenDialogService.moveEvents(vm.markedOccurrences, date, cut)
                } else {
                    var titlePrefix = "Copy and paste ";
                    if (cut) titlePrefix = "Cut and paste ";
                    var title = titlePrefix + vm.markedOccurrences.length + ' events';
                    confirmAction(title, 'Are you sure you want to ' + title, function () {
                        EventsService.moveEvents(vm.planType, vm.planning.label, vm.markedOccurrences, date, cut, successCallback);
                    });

                }
            }

            function pasteAsStartDate() {
                pasteDateInsideObject(true);
            }

            function pasteAsEndDate() {
                pasteDateInsideObject(false);
            }

            function pasteDateInsideObject(pasteAsStartDate) {
                var item = vm.selectedOccurrences[0];
                var itemUpdated = angular.copy(item);
                if (pasteAsStartDate) {
                    itemUpdated.startDate = vm.copiedDate;
                } else {
                    itemUpdated.endDate = vm.copiedDate;
                }
                if (SoopkitchenUtils.dateToSeconds(itemUpdated.startDate) > SoopkitchenUtils.dateToSeconds(itemUpdated.endDate)) {
                    AlertService.warning('End date must be greater than the start date. Action canceled.');
                    return;
                }

                if (vm.onlyEventSelection) {
                    // If event...
                    var eventDefinition = findEventDefinitionByName(item.originalName);
                    if (!eventDefinition.canModify) {
                        AlertService.warning('Duration cannot be modified manually. Action canceled.');
                        return;
                    }
                    updateEventInServer([item], [itemUpdated]);
                } else if (vm.onlyObsSelection) {
                    // If observation...
                    var observationDefinition = findObsDef(item.experiment, item.module, item.name);
                    if (canObservationDurationBeModified(observationDefinition)) {
                        AlertService.warning('Duration cannot be modified manually. Action canceled.');
                        return;
                    }
                    evaluateAndUpdateObservation(item, itemUpdated);
                }
            }

            function extendUntilNext() {
                extendObs(true);
            }

            function extendToPrevious() {
                extendObs(false);
            }

            function extendObs(untilNext) {
                var item = vm.selectedOccurrences[0];
                var itemUpdated = angular.copy(item);
                var observationDefinition = findObsDef(item.experiment, item.module, item.name);
                if (canObservationDurationBeModified(observationDefinition)) {
                    AlertService.warning('Duration cannot be modified manually. Action canceled.');
                    return;
                }
                var date = untilNext ? findNextObservationHappeningStartTime(item.experiment, item.module, item.endDate) :
                    findPrevObservationHappeningEndTime(item.experiment, item.module, item.startDate);
                if (date == null) {
                    AlertService.warning('No observation found.');
                } else {
                    if (untilNext) {
                        itemUpdated.endDate = date;
                    } else {
                        itemUpdated.startDate = date;
                    }
                    evaluateAndUpdateObservation(item, itemUpdated);
                }
            }

            // /////////
            // Copy/Paste functionality methods
            function openContextMenu(props) {
                createSelectionItems(props);

                $scope.visContextDropdownStyle = {
                    "z-index": "10000",
                    "position": "absolute",
                    "display": "block",
                    "left": props.pageX,
                    "top": props.pageY
                };

                $scope.visContextDropdownMenuStyle = {
                    "position": "static",
                    "font-size": "12.6px",
                    "display": "block"
                };

                $timeout(function () {
                    $scope.$apply();
                });
            }

            function closeContextMenu() {
                $scope.visContextDropdownStyle = {
                    "z-index": "10000",
                    "position": "absolute",
                    "display": "none"
                };

                $scope.visContextDropdownMenuStyle = {
                    "position": "static",
                    "font-size": "12.6px",
                    "display": "block"
                };

                $timeout(function () {
                    $scope.$apply();
                });
            }

            function createSelectionItems(props) {

                //here set what is selected
                var adjustedTime = new Date(props.time);
                adjustedTime.setSeconds(0, 0);
                vm.clickedVisTime = adjustedTime;
                var clickedVisId = props.item;
                if (clickedVisId != null && vm.timeline.getSelection().length === 0) {
                    vm.timeline.setSelection(clickedVisId, {})
                }
                vm.selectedOccurrences = getSelectedOccurrences();
                vm.selectionCount = vm.selectedOccurrences.length;

                vm.onlyObsSelection = areAllSelectedItemsOfType(vm.selectedOccurrences, 'observation');
                vm.onlyEventSelection = areAllSelectedItemsOfType(vm.selectedOccurrences, 'event');
                vm.onlySoopSelection = areAllSelectedItemsOfType(vm.selectedOccurrences, 'soop');

                vm.isThereContextMenu = false;
                var menuEntries = Object.entries(vm.contextMenu);
                for (var i = 0; i < menuEntries.length; i++) {
                    if (menuEntries[i][1].contextPermitted() && menuEntries[i][1].userAccessPermitted) {
                        vm.isThereContextMenu = true;
                    }
                }
            }

            function findPrevObservationHappeningEndTime(experiment, module, date) {
                var inputSeconds = SoopkitchenUtils.dateToSeconds(date);
                var currentMinimumDistance = Number.MAX_SAFE_INTEGER;
                var currentSelectedObs = null;
                for (var i = 0; i < vm.planning.observationInstanceTimeline.happenings.length; i++) {
                    var obsInstance = vm.planning.observationInstanceTimeline.happenings[i];
                    if ((obsInstance.experiment === experiment) && (obsInstance.module === module)) {
                        var timeDiff = inputSeconds - SoopkitchenUtils.dateToSeconds(obsInstance.endDate);
                        if ((timeDiff > 0) && (timeDiff < currentMinimumDistance)) {
                            currentMinimumDistance = timeDiff;
                            currentSelectedObs = i;
                        }
                    }
                }
                if (currentSelectedObs != null) {
                    return vm.planning.observationInstanceTimeline.happenings[currentSelectedObs].endDate;
                }
                return null;
            }

            function findNextObservationHappeningStartTime(experiment, module, date) {
                var inputSeconds = SoopkitchenUtils.dateToSeconds(date);
                var currentMinimumDistance = Number.MAX_SAFE_INTEGER;
                var currentSelectedObs = null;
                for (var i = 0; i < vm.planning.observationInstanceTimeline.happenings.length; i++) {
                    var obsInstance = vm.planning.observationInstanceTimeline.happenings[i];
                    if ((obsInstance.experiment === experiment) && (obsInstance.module === module)) {
                        var timeDiff = SoopkitchenUtils.dateToSeconds(obsInstance.startDate) - inputSeconds;
                        if ((timeDiff > 0) && (timeDiff < currentMinimumDistance)) {
                            currentMinimumDistance = timeDiff;
                            currentSelectedObs = i;
                        }
                    }
                }
                if (currentSelectedObs != null) {
                    return vm.planning.observationInstanceTimeline.happenings[currentSelectedObs].startDate;
                }
                return null;
            }

            function findObsDef(experiment, module, name) {
                return vm.observationsPerInstrument[experiment].allObservations[module][name];
            }

            function findEventDefinitionByName(eventName) {
                for (var i = 0; i < vm.planning.schema.eventDefinitions.length; i++) {
                    var eventDefinition = vm.planning.schema.eventDefinitions[i];
                    if (eventDefinition.name === eventName) {
                        return eventDefinition;
                    }
                }
                return null;
            }

            function canObservationDurationBeModified(obsDef) {
                return obsDef.duration.valueType !== 'NUMBER';
            }

            function insertSoopTemplateAtClickedTime() {
                PlanningDetailOpenDialogService.doInsertSoopTemplateAtTime(SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function insertSoopTemplateAtStartTime() {
                PlanningDetailOpenDialogService.doInsertSoopTemplateAtTime(vm.selectedOccurrences[0].startDate);
            }

            function changeMetisCompatibilityAtInterval() {
                vm.selectedOccurrences.sort(function(a, b) {
                    // Assuming startDate is a Date object or a string that can be compared
                    if (a.startDate < b.startDate) {
                        return -1;
                    }
                    if (a.startDate > b.startDate) {
                        return 1;
                    }
                    return 0;
                });
                PlanningDetailOpenDialogService.doChangeMetisCompatibilityAtStartTime(vm.selectedOccurrences[0].startDate, vm.selectedOccurrences[vm.selectedOccurrences.length-1].endDate);
            }


            function insertSoopTemplateAtEndTime() {
                PlanningDetailOpenDialogService.doInsertSoopTemplateAtTime(vm.selectedOccurrences[0].endDate);
            }

            function insertPlanTemplateAtClickedTime() {
                PlanningDetailOpenDialogService.doInsertPlanTemplateAtTime(SoopkitchenUtils.formattedDate(vm.clickedVisTime));
            }

            function insertPlanTemplateAtStartTime() {
                PlanningDetailOpenDialogService.doInsertPlanTemplateAtTime(vm.selectedOccurrences[0].startDate);
            }

            function insertPlanTemplateAtEndTime() {
                PlanningDetailOpenDialogService.doInsertPlanTemplateAtTime(vm.selectedOccurrences[0].endDate);
            }

            function createSOOPFromTimeLine() {
                PlanningDetailOpenDialogService.doCreateSOOPFromTimeLine(vm.selectedOccurrences);
            }

            function doAddObsToSoop() {
                var soopInstances = vm.selectedOccurrences.map(function (soop) {
                    var rObj = {};
                    rObj[soop.encodedSoopType] = soop.soopInstanceId;
                    return rObj;
                });

                Planning.addToSoop(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        soopInstances: soopInstances
                    },
                    vm.markedOccurrences,
                    function successCallback(data) {
                        reloadPlan(null, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function addObservationsToSOOP() {
                var title = "Add observations to soop";
                var msg = '<h4>Are you sure you want to add the following observations to SOOP</h4><hr/>';
                msg += createObsHtmlTable(vm.markedOccurrences);
                confirmAction(title, msg, doAddObsToSoop);
            }

            function doDetachObsFromSoop() {

                var soopIdSet = new Set();
                vm.selectedOccurrences.forEach(function(obs) {
                    if (obs.compositeId && obs.compositeId.compositeSoopIds) {
                        obs.compositeId.compositeSoopIds.forEach(function(soop) {
                            if (soop.encodedSoopType !== '000') {
                                soopIdSet.add(soop.encodedSoopType + '_' + soop.soopInstanceId);
                            }
                        });
                    }
                });

                var soopInstances = Array.from(soopIdSet).map(function(soopString) {
                    var parts = soopString.split('_');
                    var rObj = {};
                    rObj[parts[0]] = parts[1];
                    return rObj;
                });

                if (soopInstances.length === 0) {
                    AlertService.warning("No SOOPs to detach from were found in the selected observations.");
                    return;
                }

                var observationsToDetach = vm.selectedOccurrences;

                Planning.detatchFromSoop(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label,
                        soopInstances: soopInstances
                    },
                    observationsToDetach,
                    function successCallback(data) {
                        AlertService.success("Successfully detached " + observationsToDetach.length + " observation(s).");
                        reloadPlan(null, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function detachObservationsFromSOOP() {
                var title = "Detach observations from soop";
                var msg = '<h4>Are you sure you want to detach the following observations from the SOOP</h4><hr/>';
                msg += createObsHtmlTable(vm.selectedOccurrences);
                confirmAction(title, msg, doDetachObsFromSoop);
            }

            function getSelectedOccurrences() {
                var selected = [];
                findByIDs(vm.timeline.getSelection()).forEach(function (item) {
                    selected.push(item.occurrence);
                });
                return selected;
            }

            function findByIDs(ids) {
                return vm.items.get({
                    filter: function (item) {
                        for (var i = 0; i < ids.length; i++) {
                            if (item.id === ids[i]) {
                                return true;
                            }
                        }
                        return false;
                    }
                });
            }

            function areAllSelectedItemsOfType(occurrences, type) {
                if (occurrences.length === 0) {
                    return false;
                }
                for (var i = 0; i < occurrences.length; i++) {
                    if (occurrences[i].type !== type) {
                        return false;
                    }
                }
                return true
            }

            function evaluateAndUpdateObservation(prevObservation, observation) {
                var params = {
                    "obsDefLabel": vm.planning.observationDefinitions.label,
                    "experiment": observation.experiment,
                    "obsModule": observation.module,
                    "obsName": observation.name,
                    "startTime": observation.startDate,
                    "endTime": observation.endDate,
                    "overwrittenNumberParams": observation.numberParameters,
                    "comment": observation.comment
                };
                $http({
                    method: 'POST',
                    url: 'api/obsInstance',
                    params: params
                }).then(function successCallback(response) {
                    AlertService.success("Evaluation of Observation successful");
                    updateObservationInServer([prevObservation], [response.data]);
                }, function errorCallback(response) {
                    AlertService.warning("Evaluation of Observation failed; update canceled.");
                });
            }

            function updateEventInServer(existingEvents, updatedEvents) {
                var listEvents = [];
                for (var i = 0; i < existingEvents.length; i++) {
                    listEvents.push(
                        {
                            "updatedHappening": updatedEvents[i],
                            "existingHappening": existingEvents[i]
                        }
                    );
                }

                PlanningEventsService.updateEvent(
                    {
                        planLabel: vm.planning.label
                    },
                    {"updateList": listEvents},
                    function successCallback(data) {
                        if (updatedEvents.length === 1) {
                            reloadPlan(updatedEvents[0], data);
                        } else {
                            reloadPlan(null, data);
                        }
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    });
            }

            function updateObservationInServer(existingObs, updatedObs) {
                var listObservations = [];
                for (var i = 0; i < existingObs.length; i++) {
                    listObservations.push(
                        {
                            "updatedHappening": updatedObs[i],
                            "existingHappening": existingObs[i]
                        }
                    );
                }

                Planning.updateObsInstance(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label
                    },
                    {"updateList": listObservations},
                    function successCallback(data) {
                        if (updatedObs.length === 1) {
                            reloadPlan(updatedObs[0], data);
                        } else {
                            reloadPlan(null, data);
                        }
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function saveEventInServer(eventsToAdd) {
                PlanningEventsService.addEvent(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label
                    },
                    eventsToAdd,
                    function successCallback(data) {
                        reloadPlan(eventToAdd, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function saveObservationInServer(observationToAdd) {
                var obsList = [];
                obsList.push(observationToAdd);
                Planning.addObsInstance(
                    {
                        planType: vm.planType,
                        planLabel: vm.planning.label
                    },
                    obsList,
                    function successCallback(data) {
                        reloadPlan(observationToAdd, data);
                    }, function errorCallback(response) {
                        SoopkitchenUtils.prettyError(response);
                    }
                );
            }

            function getVisLastItemId() {
                var idsArray = vm.items.getIds();
                return idsArray[idsArray.length - 1];
            }

            function isSoopGroup(groupName) {
                if (soopsGroup === groupName) {
                    return true;
                }
                return false;
            }

        }
    }

)
();
